/// <amd-module name="Wiki/HeaderMetaData/HeaderMetaDataComponent" />

import * as React from "react";
import { format } from "VSS/Core/Util/String";
import { VssComponent } from "VSS/Platform/Layout";
import { Ago } from "VSSUI/Ago";
import { KeyCode } from "VSSUI/Util";
import { WikiPage, WikiV2 } from "Wiki/Clients/Wiki/Contracts/Wiki";
import { EditorComponent } from "Wiki/HeaderMetaData/EditorComponent";
import { IHeaderMetaDataState } from "Wiki/HeaderMetaData/Interfaces/IHeaderMetadataTypes";
import * as Resources from "Wiki/HeaderMetaData/Resources";
import { TelemetryConstants } from "Wiki/ViewCommon/CustomerIntelligenceConstants";
import { getFileName } from "Wiki/ViewCommon/Utils/PathHelper";
import { getWikiTypeString, publish } from "Wiki/ViewCommon/Utils/WikiHelper";
import { showWrappedDialog } from "Wiki/ViewCommon/WrappedDialogHelper";

export interface HeaderMetaDataProps {
    headerMetaDataState: IHeaderMetaDataState;
    wiki: WikiV2;
    page: WikiPage;
    onUpdateLinkWitClick: (count: number) => void;
    hasWikiContributePermission?: boolean;
}

export class HeaderMetaDataComponent extends VssComponent<HeaderMetaDataProps, {}> {
    public render(): JSX.Element {
        const { pushDate, pusher, workItemsCount } = this.props.headerMetaDataState;
        const witString = format(workItemsCount > 1 ? Resources.WorkItemsFormat : Resources.WorkItemFormat, workItemsCount);
        const locale = navigator.language.toLocaleLowerCase();
        
        return (
            <div className="wiki-page-metadata flex-row flex-center">
                {pusher && <EditorComponent identity={pusher} pageContext={this.context.pageContext} />}
                {pushDate && <Ago date={pushDate} locale={locale} className="last-updated-date" />}
                {workItemsCount > 0 && (
                    <div
                        className="work-items-linked cursor-pointer"
                        onClick={this._linkWitCountClicked}
                        onKeyDown={this._handleKeyDown}
                        role="button"
                        tabIndex={0}
                    >
                        {witString}
                    </div>
                )}
            </div>
        );
    }

    private _handleKeyDown = (e: React.KeyboardEvent<HTMLDivElement>): void => {
        if (e.keyCode === KeyCode.enter || e.keyCode === KeyCode.space) {
            this._linkWitCountClicked();
        }
    };

    private _linkWitCountClicked = (): void => {
        publish(this.context.pageContext, TelemetryConstants.LinkWitCountClicked);

        const { wiki, page, onUpdateLinkWitClick, hasWikiContributePermission } = this.props;
        const title = getFileName(page.path);
        showWrappedDialog(
            this.context.pageContext,
            {
                title: title,
                wikiId: wiki.id,
                wikiPagePath: page.path,
                wikiType: getWikiTypeString(wiki.type),
                onUpdateButtonClick: onUpdateLinkWitClick,
                hasWikiContributePermission: hasWikiContributePermission
            },
            "Wiki.LinkWitPanel",
            ["ms.vss-wiki-web.wiki-linkwit-content"]
        );
    };
}

VssComponent.register("Wiki.OverviewMetaDataHeader", HeaderMetaDataComponent);
